export default "__VITE_ASSET__BC6uHpcN__"